"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.termsView = void 0;
exports.termsView = {
    isEnable: true,
    componentStyle: {
        backgroundColor: 'ffffff',
    },
    additionalTermsText: '',
    additionalTermsStyle: {
        color: '000000',
        fontSize: '16px',
        textAlign: 'left',
    },
    termsText: 'Powered by Flarie ® By playing the game you accept these Terms & Policies',
    termsTextStyle: {
        color: 'ffffff',
        fontSize: '12px',
        textAlign: 'center',
    },
    disableTermsButtonShadow: false,
};
